(function () {
  'use strict';

  if (window.FellinoraScrollTextLoaded) {
    return;
  }

  window.FellinoraScrollTextLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('fst-js');

  function setRevealDelays(section) {
    var revealItems = section.querySelectorAll('[data-fst-reveal]');

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--fst-delay', Math.min(index * 130, 420) + 'ms');
    });
  }

  function initReveal(section) {
    setRevealDelays(section);

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      section.querySelectorAll('[data-fst-reveal]').forEach(function (item) {
        item.classList.add('fst-is-visible');
      });
      section.classList.add('fst-is-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fst-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -8% 0px'
    });

    section.querySelectorAll('[data-fst-reveal]').forEach(function (item) {
      observer.observe(item);
    });
  }

  function initSection(section) {
    initReveal(section);
  }

  function init() {
    document.querySelectorAll('[data-fst-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-fst-section]') ? event.target : event.target.querySelector('[data-fst-section]');

    if (section) {
      initSection(section);
    }
  });
})();
